@if(!this.dialogConfig){
  <div class="grid grid-nogutter mb-3">
    <div class="col-12 md:col-6 sm:col-12 sm:mb-2">
      <h1 class="h4 m-0">{{(editId? 'Edit A Credential': 'Add A Credential') | sentenceCase}}</h1>
      @if(!this.fromOnboarding){
        <p-breadcrumb class="max-w-full p-0" [model]="breadcrumbs" />
      }
    </div>
  </div>
}
<div>
  <form [formGroup]="credentialForm">
    <div class="flex flex-column justify-content-between" [ngClass]="{'h-page-full': !dialogConfig}">
      <div class="grid" [ngClass]="{'xl:w-9 w-full pt-4': !dialogConfig}">
        @if( isYearlyRenewal && credName){

        <span
          style="
            font-size: 14px;
            background-color: beige;
            padding: 5px;
            margin-top: 20px;
          "
          layout="row"
          ng-if="isYearlyRenewal"
        >
          <i
            style="color: red; margin-right: 10px"
            class="pi pi-exclamation-circle"
          ></i
          >{{ firmName }} requires {{ credName }} be kept up to date. Please
          provide Issuance and Expiration dates. You will be prompted to renew
          these after one year of issuance or on the expiration date.</span
        >
        }
        <div class="col-12">
          <p-floatLabel>
            <p-dropdown
              formControlName="credentials"
              [options]="dropDownList"
              optionLabel="displayName"
              inputId="selectCredentials"
              appendTo="body"
              (onChange)="onDropdownChange($event.value)"
            />
            <label for="selectCredentials">{{'Select a Credential' | sentenceCase}}<span class="required">*</span></label>
          </p-floatLabel>
        </div>
        <div class="lg:col-6 col-12">
          <p-floatLabel>
            <p-calendar
              [maxDate]="maxIssuedAt"
              appendTo="body"
              dateFormat="mm.dd.yy"
              [showIcon]="true"
              inputId="issueDate"
              [placeholder]="'Issue Date' | sentenceCase"
              formControlName="issuedAt"
              (onSelect)="onIssueDateChange($event)"
            />
            <label for="issueDate">{{'Issue Date' | sentenceCase}}<span class="required">*</span></label>
          </p-floatLabel>
          @if(credentialForm.controls['issuedAt'].dirty || credentialForm.controls['issuedAt'].touched || !formValid){
            @if(credentialForm.controls['issuedAt'].errors?.['required']){
                <div class="p-error ">This is required.</div>
            }
        }
        </div>
        @if(isPwcEnabled){
          <div class="lg:col-6 col-12">
            <p-floatLabel>
              <input
                pInputText
                type="text"
                formControlName="membershipNumber"
                id="membershipNumber"
                [placeholder]="'Membership Number' | sentenceCase"
              />
              <label for="membershipNumber">{{'Membership Number' | sentenceCase}}</label>
            </p-floatLabel>
          </div>
        } @else {
          <div class="lg:col-6 col-12">
            <p-floatLabel>
              <p-calendar
                [minDate]="minExpiresAt"
                appendTo="body"
                dateFormat="mm.dd.yy"
                [showIcon]="true"
                formControlName="expiresAt"
                inputId="expirationDate"
                [placeholder]="'Expiration Date' | sentenceCase"
              />
              <label for="expirationDate">{{'Expiration Date' | sentenceCase}}</label>
            </p-floatLabel>
          </div>
        }
        <!-- Multi-select on add for Staftr (one record is created per selected
             value); single value on edit (a record holds exactly one value) and
             always on PWC, where a reviewer adds one secondary option at a time -->
        @if(secondaryOptionsDropdown && secondaryOptionsDropdown.length){
          <div class="col-12">
            <p-floatLabel>
              @if(editId || isPwcEnabled){
                <p-dropdown
                  formControlName="secondaryOptions"
                  [options]="secondaryOptionsDropdown"
                  inputId="secondaryOptions"
                  [placeholder]=" headingText | sentenceCase"
                  [resetFilterOnHide]="true"
                />
              } @else {
                <p-multiSelect
                  formControlName="secondaryOptions"
                  [options]="secondaryOptionsDropdown"
                  inputId="secondaryOptions"
                  [placeholder]=" headingText | sentenceCase"
                  [resetFilterOnHide]="true"
                />
              }
              <label for="secondaryOptions">{{ headingText | sentenceCase}}</label>
            </p-floatLabel>
          </div>
        }
        <!-- MP-5727: the Active switch is the reviewer's own flag; the FM
             dialog never shows it (firm deactivation goes through the
             profile row and Removed Credentials) -->
        @if(isPwcEnabled && !dialogConfig){
          <div class="lg:col-6 col-12 switch-w-label ml-1 mt-3 flex gap-2">
              <label for="cred" class="line-height-2">Active?</label>
              <p-inputSwitch formControlName="isReviewerActivated" class="mpl-switch" inputId="cred" />
          </div>
        }
        <div class="col-12">
          <input
            type="file"
            #fileUpload
            style="display: none"
            accept="application/pdf"
            (change)="onFileSelect($event)"
          />
          <div class="flex align-items-center mt-4 mb-5">

            <p-button
              (click)="fileUpload.click()"
              label="upload certificate"
              rounded="true"
              size="large"
              icon="pi pi-plus"
            ></p-button>
            @if(isFormSubmitWithoutFile && !file){
                <span pTooltip="Documentation is Required" tooltipPosition="top" class="{{helperService.getEnvironmentName()}}-icon icon-error-outlined incomplete-icon red"></span>
            }
          </div>
          @if(file){
            <div class="flex align-items-center mt-4 mb-5">
              <span>{{ file.name }}
              </span>
              <p-button pTooltip="Remove" tooltipPosition="top"  [text]="true" styleClass="red" class="ml-4" size="small" rounded="true" icon="pi pi-times" (click)="removeFile()"></p-button>

            </div>
          }
          
        </div>
      </div>
      <div class="flex gap-3">
        <p-button
          label="cancel"
          rounded="true"
          outlined="true"
          size="large"
          styleClass="white-space-nowrap"
          (onClick)="onDiscard(false)"
        ></p-button>
        <p-button
          [disabled]="!credentialForm.valid"
          label="save"
          rounded="true"
          size="large"
          styleClass="white-space-nowrap freshgreen-background"
          (onClick)="onSubmit()"
        ></p-button>
      </div>
    </div>
  </form>
</div>